import React from "react"

class ImportMultiSelect extends React.Component {

  constructor(props) {
    super(props);
    this.multiSelect = React.createRef()
  };

  componentDidMount() {
    var self = this;
    var values = []
    
    if (this.props.values) {
      this.props.values.map((value) => {
        values.push(value)
      })
    }

    $(this.refs.multiSelect).select2({
      data: values,
      placeholder: I18n.t('select_ellipsis'),
      multiple: true,
      disabled: this.props.disabled,
      allowClear: true,
      templateSelection: function (value) {
        if (value && value.id != null && value.id != "") {
          self.props.onChange($(self.refs.multiSelect).select2('data'), self.props.name)
          
          return value.text;
        } else {
          return value.text;
        }
      }
    }).on('select2:unselect', function () {
      self.props.onChange($(self.refs.multiSelect).select2('data'), self.props.name);
    });

    $(this.refs.multiSelect).val(values);
    $(this.refs.multiSelect).trigger('change');
  };

  shouldComponentUpdate(nextProps, nextState) {
    return false
  };

  render() {
    var values = []
    if (this.props.values) {
      this.props.values.map((value) => {
        values.push({"id": value, "text": value, "selected": true})
      })
    }

    return (
      <div className="multi-select">
        <select className="form-control" ref="multiSelect" value={values} style={{ width: '100%', minHeight: 33 }} id="select" multiple={true}>
          {this.renderOptions()}
        </select>
        {this.renderFieldError()}
      </div>
    );
  };

  renderOptions() {
    var options = []
    this.props.options.map((value) => {
      options.push({"id": value, "text": value})
    })
    if (options && options.length) {
      var new_options = options.map((option) => {
        return <option key={option.id} text={option.text} value={option.id}>{option.text}</option>
      });
    };
    return new_options
  };

  renderFieldError() {
    if (this.props.hasError) {
      $('.multi-select').find('.select2-container--default .select2-selection--multi .select2-selection__rendered').addClass(this.props.hasError)
    };
  };

};

export default ImportMultiSelect
